<template>
  <div class="mb-4" v-if="show">
    <div>
      <h6 class="fw-bold">
        {{ 'Shipment information' | translate }}
      </h6>
      <div class="mb-2">
        <div>
          <div class="card mb-2">
            <div class="card-body">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="shipmentTypeParcelLocker"
                  value="parcel_locker"
                  v-model="shipmentType"
                  name="shipmentType"
                />
                <label class="form-check-label d-flex justify-content-between" for="shipmentTypeParcelLocker">
                  <small>{{ 'Parcel locker' | translate }} Inpost</small>
                  <small>{{ shippingCost['parcel_locker'] | price('PLN') }}</small>
                </label>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="shipmentTypeCourier"
                  value="courier"
                  v-model="shipmentType"
                  name="shipmentType"
                />
                <label class="form-check-label d-flex justify-content-between" for="shipmentTypeCourier">
                  <small>{{ 'Courier' | translate }}</small>
                  <small>{{ shippingCost['courier'] | price('PLN') }}</small>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="shipmentType === 'parcel_locker'" class="row">
        <div class="col-12 mb-2">
          <label class="small">{{ 'Parcel locker' | translate }}</label>
          <Select
            v-model="selectedLocker"
            :options="lockerOptions"
            :filterable="true"
            :searchable="true"
            :loading="loadingLockers"
            @search="onLockerSearch"
            label="display"
            :placeholder="$t('Search') + '...'"
            
          >
            <template #option="{ name, address }">
              <div>
                <span class="fw-bold small">{{ name }}</span>
              </div>
              <div>
                <span class="small">{{ address }}</span>
              </div>
            </template>
            <template #selected-option="{ name, address }">
              <div>
                <span class="fw-bold small">{{ name }}</span>
                <br>
                <span class="small">{{ address }}</span>
              </div>
            </template>
            <template #no-options="{}">
              <span class="small">{{ 'No parcel lockers found' | translate }}</span>
            </template>
          </Select>
          <InputErrors name="shipping_data.parcelLockerCode" />
        </div>
      </div>

      <div v-if="shipmentType === 'courier'" class="row">
        <div class="col-12 mb-2">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="differentShippingAddress"
              v-model="differentShippingAddress"
            />
            <label class="form-check-label small" for="differentShippingAddress">
              {{ 'Different shipping address' | translate }}
            </label>
          </div>
        </div>

        <div v-if="differentShippingAddress" class="col-12">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-2">
                <label for="name">
                  <small>{{ 'Name' | translate }}</small>
                </label>
                <input
                  key="name"
                  id="name"
                  v-model="shippingFirstName"
                  autocomplete="off"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-2">
                <label for="last_name">
                  <small>
                    {{ 'Last name' | translate }}
                  </small>
                </label>
                <input id="last_name" v-model="shippingLastName" autocomplete="off" class="form-control" type="text" />
              </div>
            </div>
            <div class="col-12 mb-2">
              <label class="small">{{ 'Phone' | translate }}</label>
              <input
                v-model="phoneNumber"
                v-mask="'#########'"
                type="text"
                class="form-control"
                placeholder="123456789"
              />
              <small><InputErrors name="shipping_data.phoneNumber" /></small>
            </div>

            <div class="col-12 mb-2">
              <label class="small">{{ 'Address' | translate }}</label>
              <input v-model="address" type="text" class="form-control" placeholder="Street, Number" />
              <small><InputErrors name="shipping_data.address" /></small>
            </div>

            <div class="col-md-4 mb-2">
              <label class="small">{{ 'Postal code' | translate }}</label>
              <input
                v-model="postalCode"
                v-mask="'##-###'"
                type="text"
                class="form-control"
                placeholder="00-000"
                key="postal_code"
              />
              <small><InputErrors :errors="errors['shipping_data.postalCode']" /></small>
            </div>

            <div class="col-md-8 mb-2">
              <label class="small">{{ 'City' | translate }}</label>
              <input v-model="city" type="text" class="form-control" placeholder="City" key="city" />
              <small><InputErrors name="shipping_data.city" /></small>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <label class="small text-muted" for="shipping_notes">{{ 'Shipping notes' | translate }}</label>
        <textarea v-model="shippingNotes" class="form-control" id="shipping_notes" rows="1"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import Select from 'vue-select'
import InputErrors from './../InputErrors'
import { mask } from 'vue-the-mask'
import _ from 'lodash'

export default {
  directives: { mask },
  components: {
    Select,
    InputErrors,
  },
  data() {
    return {
      lockerOptions: [],
      loadingLockers: false,
    }
  },
  created() {
    this.debouncedLockerSearch = _.debounce(this.fetchLockers, 400)
  },
  filters: {
    price(value, currency) {
      return (value / 100).toLocaleString(document.documentElement.lang, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
      })
    },
  },
  computed: {
    errors() {
      return this.$store.state.errors
    },
    productTypeIsPhysical() {
      return this.$store.state.course.type === 'physical'
    },
    show() {
      return this.productTypeIsPhysical
    },
    shippingCost() {
      return this.$store.state.shippingCost
    },
    shippingFirstName: {
      get() {
        return this.$store.state.shippingData.firstName
      },
      set(value) {
        this.$store.commit('SET_SHIPPING_FIRST_NAME', value)
      },
    },
    shippingLastName: {
      get() {
        return this.$store.state.shippingData.lastName
      },
      set(value) {
        this.$store.commit('SET_SHIPPING_LAST_NAME', value)
      },
    },
    differentShippingAddress: {
      get() {
        return this.$store.state.shippingData.differentShippingAddress
      },
      set(value) {
        this.$store.commit('SET_DIFFERENT_SHIPPING_ADDRESS', value)
      },
    },
    shipmentType: {
      get() {
        return this.$store.state.shippingData.shipmentType
      },
      set(value) {
        this.$store.commit('SET_SHIPPING_TYPE', value)
      },
    },
    selectedLocker: {
      get() {
        return this.$store.state.shippingData.selectedLocker
      },
      set(value) {
        this.$store.commit('SET_SELECTED_LOCKER', value)
        // Optionally, also set parcelLockerCode when locker changes
        this.parcelLockerCode = value ? value.name : ''
      },
    },
    parcelLockerCode: {
      get() {
        return this.$store.state.shippingData.parcelLockerCode
      },
      set(value) {
        this.$store.commit('SET_PARCEL_LOCKER_CODE', value)
      },
    },
    address: {
      get() {
        return this.$store.state.shippingData.address
      },
      set(value) {
        this.$store.commit('SET_SHIPPING_ADDRESS', value)
      },
    },
    city: {
      get() {
        return this.$store.state.shippingData.city
      },
      set(value) {
        this.$store.commit('SET_SHIPPING_CITY', value)
      },
    },
    shippingNotes: {
      get() {
        return this.$store.state.shippingData.notes
      },
      set(value) {
        this.$store.commit('SET_SHIPPING_NOTES', value)
      },
    },
    postalCode: {
      get() {
        return this.$store.state.shippingData.postalCode
      },
      set(value) {
        this.$store.commit('SET_SHIPPING_POSTAL_CODE', value)
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.shippingData.phoneNumber
      },
      set(value) {
        this.$store.commit('SET_SHIPPING_PHONE', value)
      },
    },
  },
  watch: {
    selectedLocker(val) {
      this.parcelLockerCode = val ? val.code : ''
    },
  },
  methods: {
    copyShipmentData() {
      this.$store.dispatch('copyBillingToShipping')
    },
    onLockerSearch(search) {
      if (!search) {
        this.lockerOptions = []
        return
      }
      this.loadingLockers = true
      this.debouncedLockerSearch(search)
    },
    fetchLockers(search) {
      if (search.length < 2) return

      // const url = `https://sandbox-api-pl-points.easypack24.net/v1/points`
      const url = `https://api-pl-points.easypack24.net/v1/points?query=${encodeURIComponent(search)}`

      axios
        .get(url)
        .then((res) => {
          this.lockerOptions = res.data.items
            .map((locker) => ({
              name: locker.name,
              status: locker.status,
              address: `${locker.address.line1}, ${locker.address.line2}`,
              display: `${locker.name} - ${locker.address.line1}, ${locker.address.line2}`,
            }))
        })
        .catch(() => {
          this.lockerOptions = []
        })
        .finally(() => {
          this.loadingLockers = false
        })
    },
  },
}
</script>
